import { mixins } from 'sonata-react-components';
import styled from 'styled-components';

export const AppAndSiteMarketplaceImportStyled = styled.div`
  .appAndSiteMarketplaceImport {
    &__button {
      &Container {
        display: flex;
        flex-direction: column;
        row-gap: 8px;
      }

      &Upload {
        width: 100%;
      }

      &Loading {
        font-size: ${props => props.theme.fontSizeXS};
        line-height: 16px;
        color: ${props => props.theme.uiColors.appAndSiteMarketplaceImportLoadingText};
        background: ${props => props.theme.uiColors.background07};
        width: 100%;
        border: 1px solid ${props => props.theme.uiColors.appAndSiteMarketplaceImportLoadingBorder};
        border-radius: 4px;
        display: inline-flex;
        gap: 8px;
        align-items: center;
        font-family: ${props => props.theme.fontSemiBold};
        text-wrap: nowrap;
        padding: 0 12px;
        
        &Spinner {
          padding: 5px;
          background: ${props => props.theme.uiColors.boxBgColor02};
          border-radius: 50%;
        }
        
        &File {
          color: ${props => props.theme.uiColors.textBodyDefault};
          width: 100%;
          ${mixins.ellipsis};
        }
        
        &Icon {
          justify-content: end;
        }
      }
      
      &Confirm {
        font-size: ${props => props.theme.fontSizeXS};
        line-height: 16px;
        color: ${props => props.theme.uiColors.appAndSiteMarketplaceImportLoadingText};
        background: ${props => props.theme.uiColors.background07};
        width: 100%;
        border: 1px solid ${props => props.theme.uiColors.appAndSiteMarketplaceImportLoadingBorder};
        border-radius: 4px;
        display: inline-flex;
        gap: 8px;
        align-items: center;
        font-family: ${props => props.theme.fontSemiBold};
        text-wrap: nowrap;
        padding: 0 12px;
        
        &Icon {
          padding: 5px;
          background: ${props => props.theme.uiColors.appAndSiteMarketplaceImportLoadingIcon};
          border-radius: 50%;
        }
        
        &File {
          color: ${props => props.theme.uiColors.textBodyDefault};
          width: 100%;
          ${mixins.ellipsis};
        }
        
        &Edit {
          justify-content: end;
        }
      }
    }

    &__file {
      &Container {
        display: flex;
        flex-direction: column;
        row-gap: var(--spacing-8);
      }
      &Disclaimer {
        align-items: center;
        display: flex;
        column-gap: var(--spacing-8);
        color: var(--color-status-warning-600);
        font: var(--font-info-600-regular);
      }
    }
    
    &__modal {
      border-radius: 6px;
      padding: 16px 16px 0 16px;
      width: 100%;
      
      &Description {
        display: inline-flex;
        justify-content: center;
        width: 100%;
        gap: 5px;
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeS};
      }
      
      &Button {
        display: inline-flex;
        width: 136px;
        margin: 33px calc(50% - 68px);
      }
    }
    
    &__table {
      color: ${props => props.theme.uiColors.textBodyDefault};
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeS};
      text-wrap: nowrap;
      width: 100%;
      border: 1px solid ${props => props.theme.uiColors.tableRowDisabled};
      border-radius: 6px;

      & tr {
        & th {
          background: ${props => props.theme.uiColors.appAndSiteMarketplaceImportModalBackground};
          font-family: ${props => props.theme.fontBold};
          color: ${props => props.theme.uiColors.textTitle};
          padding: 8px;
          text-align: start;
        }

        & td {
          background: transparent;
          padding: 8px;
          border-top: 1px solid ${props => props.theme.uiColors.tableRowDisabled};
          font-size: ${props => props.theme.fontSizeXS};
        }
      }
    }
    
    &__upload {
      margin-top: 130px;
      margin-right: calc(50% - 92px);
      margin-left: calc(50% - 92px);
      width: 184px;
      display: inline-flex;
    }

    &__loader {
      border-radius: 6px;
      background: ${props => props.theme.uiColors.appAndSiteMarketplaceImportModalBackground};
      min-height: 400px;
      justify-content: center;
      width: 100%;
      
      &Title {
        color: ${props => props.theme.uiColors.appAndSiteMarketplaceImportLoadingText};
        font-family: ${props => props.theme.fontSemiBold};
        font-size: ${props => props.theme.fontSizeXS};
      }
    }

    &__required {
      color: var(--color-sonata-primary-500);
      display: flex;
      font: var(--font-info-500-regular);
      justify-content: flex-end;
      margin-bottom: var(--spacing-8);

      &Asterisk {
        color: var(--color-status-error-600);
      }
    }

    &__footer {
      align-items: center;
      display: flex;
      justify-content: space-between;
      margin-top: var(--spacing-32);
    }

    &__columns {
      border-radius: 6px;
      background: ${props => props.theme.uiColors.appAndSiteMarketplaceImportModalBackground};
      
      &Description {
        display: inline-flex;
        justify-content: center;
        margin-top: 16px;
        width: 100%;
        gap: 5px;
        color: ${props => props.theme.uiColors.textBodyDefault};
        font-family: ${props => props.theme.fontRegular};
        font-size: ${props => props.theme.fontSizeS};

        > span {
          font-family: ${props => props.theme.fontBold};
          color: ${props => props.theme.uiColors.textTitle};
        }
      }
      
      &Selectors {
        width: 100%;
        flex-flow: column;
        display: flex;
        gap: 16px;
        align-items: center;
        padding: 32px 0;
        
        & > * {
          width: 380px;
        }
      }
    }
    
    &__details {
      & .listTbodyCell:last-child {
        max-width: 80px;
      }

      & .columnsHeaderContainer {
        justify-content: flex-start;

        &__title {
          flex: 1;
          text-align: left;

          &:last-child {
            max-width: 80px;
          }
        }
      }
    }
  }
`;
